import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import jwtDecode from 'jwt-decode'

const useAuth = () => {
    const token = useSelector(selectCurrentToken)
    let isManager = false
    let isAdmin = false
    let status = "Physical Therapist"

    if (token) {
        const decoded = jwtDecode(token)
        const { firstname, lastname, email, username, roles, userId } = decoded.UserInfo

        isManager = roles.includes('Manager')
        isAdmin = roles.includes('Admin')

        if (isManager) status = "Manager"
        if (isAdmin) status = "Admin"

        return { username, firstname, lastname, email, userId, roles, status, isManager, isAdmin, token }
    }

    return { username: '', firstname: '', lastname: '', email: '', userId: '', roles: [], isManager, isAdmin, status }
}
export default useAuth